import { render, staticRenderFns } from "./MeetingAgendasLayout.vue?vue&type=template&id=2cef2846&"
import script from "./MeetingAgendasLayout.vue?vue&type=script&lang=js&"
export * from "./MeetingAgendasLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cef2846')) {
      api.createRecord('2cef2846', component.options)
    } else {
      api.reload('2cef2846', component.options)
    }
    module.hot.accept("./MeetingAgendasLayout.vue?vue&type=template&id=2cef2846&", function () {
      api.rerender('2cef2846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/MeetingAgendasLayout.vue"
export default component.exports